import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { REISSUES_PERMISSIONS } from "@/app/nav";
import { ReissueQueue } from "@/features/reissue/ReissueQueue";
import { type PageSearch, pageSearch } from "@/routes/paging";
import { staffRoute } from "@/routes/staff";

type ReissuesSearch = { request?: string } & PageSearch;

export const reissuesRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "approvals/reissues",
  // Set, never omit, the key: the router merges this over the raw query string.
  validateSearch: (search: Record<string, unknown>): ReissuesSearch => ({
    request: typeof search.request === "string" && search.request !== "" ? search.request : undefined,
    ...pageSearch(search),
  }),
  beforeLoad: ({ context }) => requirePermissions(context.session, REISSUES_PERMISSIONS),
  component: ReissueQueue,
});
